<template>
  <b-container fluid class="pl-5 pr-5">
    <h4 class="m-4">以下為 "{{keyword}}" 的搜尋結果：</h4>
    <hr class="mb-0">
    <b-row class="offset-1 col-10">
      <b-col md="2" cols="12" class="border-right mh-600">
        <div class="p-3">
          <h5 style="font-weight: bold;">所有商品</h5>
          <b-list-group flush>
            <b-list-group-item 
              v-for="classify in classifies"
              :key="classify.id"
              :to="classify.link"
              :active="classify.active"
              target="_blank" class="rounded text-truncate"
            >
              {{ classify.name }}
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-col>
      <b-col md="10" cols="12" class="p-3">
        <product-list-table
          :list="list"
          :page="page"
          :each="each"
          :total="total"
          :sort="sort"
          @page:change="onPageChange"
          @sort:change="onSortChange"
          link-target="_blank"
        >
        </product-list-table>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import UrlJoin from 'url-join'
import ProductListTable from './ProductListTable'
import QueryString from 'querystring'
export default {
  components: {
    ProductListTable
  },
  data () {
    return {
      list: [],
      total: 0,
      page: 1,
      each: 10,
      sort: '',
      classifies: []
    }
  },
  computed: {
    keyword () {
      return this.$route.query.keyword
    },
    query () {
      const data = {
        page: this.page,
        each: this.each,
        sort: this.sort,
        name: this.keyword
      }
      const str = QueryString.stringify(data)
      return `?${str}`
    }
  },
  methods: {
    async start () {
      console.log(this.keyword)
      if (!this.keyword) return
      const { data: { catalogs }, headers } = await this.$api.getProdParam(this.query)
      const classifies = []
      catalogs.forEach(item => {
        const linkAry = ['/classify']
        let name = ''
        if (item.top) {
          linkAry.push(item.top.id)
          name = item.top.name
        }
        if (item.sub) {
          linkAry.push(item.sub.id)
          name = item.sub.name
        }
        const link = UrlJoin(linkAry)
        const find = classifies.find(c => c.link === link)
        if (find) return
        classifies.push({
          name,
          link,
          active: false
        })
      })
      this.list = catalogs
      this.classifies = classifies
      this.total = Number.parseInt(headers['shop-option-total']) || 0
      this.page = Number.parseInt(headers['shop-option-page']) || 1
      this.each = Number.parseInt(headers['shop-option-each']) || 10
      this.sort = headers['shop-option-sort'] || ''
    },
    onPageChange (page = 1) {
      this.page = page
      this.start()
    },
    onSortChange (sort = '') {
      this.sort = sort
      this.start()
    }
  },
  mounted () {
    this.start()
  },
  beforeRouteUpdate (to, from, next) {
    // react to route changes...
    // don't forget to call next()
    console.log('route update @ Search.vue')
    this.page = 1
    this.each = 10
    this.sort = ''
    this.$nextTick(this.start)
    next()
  }
}
</script>
<style>
  .list-group a.list-group-item {
    font-size: 1.1rem;
  }
  h4.m-4 {
	padding-left: 9.5%;
  }
  hr.mb-0 {
	margin: 0 10%;
  }
  @media (max-width: 1620px) {
  h4.m-4 {
	padding-left: unset;
  }
  hr.mb-0 {
	margin: 0;
  }
  .offset-1 {
	margin-left: 0;
  }
  .col-10 {
	padding: 0;
	flex: unset;
    max-width: unset;
  }}
</style>
